module.exports = __webpack_public_path__ + "media/images/trinityfix_featured_speaker_background-8de7d870.svg";